
export const enTranslations = {
  // Navbar
  home: "Home",
  about: "About",
  services: "Services",
  blog: "Blog",
  bookAppointment: "Book Appointment",
  appointment: "Appointment",

  // Footer
  rights: "All rights reserved",

  // Common sections
  learnMore: "Learn More",
  readMore: "Read More",

  // Hero Section
  heroTitle: "Specialized Oncology Care with Dr. Victoria Neiman",
  heroSubtitle:
    "A leading oncologist committed to providing personalized cancer care through innovative medical expertise and compassionate treatment.",

  // About Section
  aboutSectionTitle: "Dr. Victoria Neiman",
  aboutSectionSubtitle: "Leading Oncologist Specializing in Clinical Oncology and Personalized Cancer Care",
  aboutSectionText1: "Dr. Victoria Neiman is a leading expert in Clinical Oncology, Internal Medicine, and Radiotherapy, with over 30 years of experience. She heads the Oncology Inpatient Department at the Davidoff Cancer Center at Rabin Medical Center.",
  aboutSectionText2: "Her specialization focuses on uro-oncological tumors, including kidney, prostate, bladder, and testicular cancer, as well as breast cancer. Dr. Neiman is active in international clinical research, lectures at Tel Aviv University, and leads innovations in oncology.",
  aboutSectionText3: "Known for her humane and empathetic approach, she combines professionalism with personal attention to her patients. She is a member of leading professional associations, including ESMO and the Israeli Society of Clinical Oncology.",
  readFullBio: "Read Full Biography",
  yearsExperience: "30+ Years of Experience",

  // Services Section
  ourServices: "Our Services",
  servicesSubtitle:
    "Dr. Neiman offers a comprehensive range of oncological services, from diagnosis through treatment and long-term care planning.",
  viewAllServices: "View All Services",

  // Testimonials Section
  patientTestimonials: "Patient Testimonials",
  testimonialsSubtitle:
    "Read what our patients are saying about their experience with Dr. Victoria Neiman.",

  // Appointment Section
  scheduleAppointment: "Schedule an Appointment",
  appointmentText:
    "Take the first step towards personalized cancer care by scheduling an appointment with Dr. Victoria Neiman. Our team is ready to assist you and provide the support you need throughout this journey.",
  callUs: "Call Us",
  emailUs: "Email Us",
  officeHours: "Office Hours",
  bookOnline: "Book Online",
  orCallDirectly: "Or Call Directly",
  clinicLocation: "Clinic Location",
  easyAccess: "Easy Access",

  // Blog Section
  blogSectionTitle: "Latest Medical Insights",
  blogSectionSubtitle:
    "Stay updated with the latest research, treatment options, and health insights from Dr. Victoria Neiman.",
  viewAllPosts: "View All Posts",

  // News Section
  inTheNews: "In The News",
  newsSubtitle:
    "Dr. Victoria Neiman's contributions to oncological research and patient care featured in medical publications and media outlets.",
  readOriginal: "Read Original Article",

  // Footer
  quickLinks: "Quick Links",
  contactInfo: "Contact Information",
  officeHoursFooter: "Office Hours",
  privacyPolicy: "Privacy Policy",
  termsOfService: "Terms of Service",
  adminLogin: "Admin Login",

  // Services page
  servicesHeroTitle: "Our Services",
  servicesHeroSubtitle:
    "Dr. Victoria Neiman offers comprehensive oncological services with an emphasis on personalized care and compassionate treatment.",

  // CTA Section
  readyForNextStep: "Ready for the Next Step?",
  scheduleCTA:
    "Schedule a consultation with Dr. Victoria Neiman to discuss your condition and explore the best treatment options for your specific needs.",

  // FAQ Section
  frequentlyAskedQuestions: "Frequently Asked Questions",
  faqSubtitle:
    "Find answers to common questions about our oncological services",
  dontSeeQuestion:
    "Don't see your question here? Feel free to contact us directly.",

  // Appointment Page
  scheduleAnAppointment: "Schedule an Appointment",
  appointmentDescription:
    "Request an appointment with Dr. Victoria Neiman. We will contact you shortly to confirm your appointment time.",
  requestAnAppointment: "Request an Appointment",

  // Appointment Form
  fullName: "Full Name",
  email: "Email",
  phoneNumber: "Phone Number",
  date: "Date",
  time: "Time",
  selectDate: "Select a Date",
  selectTime: "Select a Time",
  reasonForVisit: "Reason for Visit",
  selectReason: "Select a Reason",
  additionalInformation: "Additional Information (Optional)",
  additionalInfoPlaceholder:
    "Please share any additional information about your condition or specific concerns.",
  submitRequest: "Submit Request",
  submitting: "Submitting...",

  // Office Hours and Contact Info
  contactInformation: "Contact Information",
  phone: "Phone",
  address: "Address",
  mondayThursday: "Sunday - Thursday",
  friday: "Friday",
  saturday: "Saturday",
  sunday: "Sunday",
  closed: "Closed",
  officeHoursSchedule: "Monday-Thursday: 9:00-17:00, Friday: 9:00-14:00",

  // Form placeholders
  namePlaceholder: "John Smith",
  emailPlaceholder: "your@email.com",
  phonePlaceholder: "+1 (555) 123-4567",

  // Appointment Reasons
  initialConsultation: "Initial Consultation",
  followUp: "Follow-Up Visit",
  treatmentDiscussion: "Treatment Discussion",
  secondOpinion: "Second Opinion",
  testResultsReview: "Test Results Review",
  other: "Other",

  skipToContent: "Skip to main content",

  // Service titles and descriptions
  cancerDiagnosis: "Cancer Diagnosis",
  cancerDiagnosisDesc:
    "Comprehensive diagnostic services including advanced imaging, biopsies, and genetic testing to determine the exact nature and stage of your cancer.",
  personalizedTreatment: "Personalized Treatment Plans",
  personalizedTreatmentDesc:
    "Tailored treatment strategies created specifically for your condition, taking into account your cancer type, stage, genetic profile, and personal health factors.",
  chemotherapy: "Chemotherapy",
  chemotherapyDesc:
    "Administration and management of chemotherapy protocols with close monitoring and supportive care to minimize side effects and maximize effectiveness.",
  immunotherapy: "Immunotherapy",
  immunotherapyDesc:
    "Advanced immunotherapy treatments that enlist your immune system to fight cancer, with specialized expertise in the latest protocols.",
  targetedTherapy: "Targeted Therapy",
  targetedTherapyDesc:
    "Precision medicine approaches that target specific genetic mutations or proteins involved in your cancer's growth and spread.",
  survivorshipCare: "Survivorship Care",
  survivorshipCareDesc:
    "Long-term follow-up care and wellness planning for cancer survivors, addressing both physical and psychological aspects of life after cancer.",

  // Research Section
  selectedPublications: "Selected Publications",
  researchInterests: "Research Interests",
  publication1:
    'Neiman V, et al. (2022) "Efficacy and toxicity of hypofractionated radiotherapy in breast cancer patients." Current Oncology Issues.',
  publication2:
    'Neiman V, et al. (2022) "Real-world experience with dose-intense or dose-dense anthracyclines and taxanes for triple-negative breast cancer patients." Current Oncology Issues.',
  publication3:
    'Neiman V, et al. (2021) "Outcomes of triple-negative breast cancer patients treated with palliative bevacizumab." The Oncologist.',
  publication4:
    'Neiman V, et al. (2020) "Efficacy and toxicity of dose-dense doxorubicin and cyclophosphamide (ddAC) in breast cancer patients: a single-center experience." Clinical Breast Cancer.',
  publication5:
    'Neiman V, et al. (2019) "The efficacy and toxicity of angiotensin II receptor blockers in the adjuvant setting for breast cancer patients: A systematic review." Journal of Clinical Oncology.',

  personalizedCancer: "Personalized Cancer Treatment",
  personalizedCancerDesc:
    "Developing personalized treatment approaches based on genetic and molecular profiling of tumors.",
  immunotherapyOptimization: "Immunotherapy Optimization",
  immunotherapyOptimizationDesc:
    "Enhancing efficacy and reducing adverse effects of immunotherapy across various cancer types.",
  cancerInElderly: "Cancer in Elderly Patients",
  cancerInElderlyDesc:
    "Specialized approaches to cancer care in geriatric patients, balancing efficacy and quality of life.",
  combinationTherapy: "Combination Treatment Protocols",
  combinationTherapyDesc:
    "Investigating synergistic effects of combining different treatment modalities for improved outcomes.",

  // Accessibility Widget
  accessibilityOptions: "Accessibility Options",
  fontSize: "Font Size",
  brightness: "Brightness",
  highContrast: "High Contrast",
  on: "On",
  off: "Off",
  resetAll: "Reset All",
  adjustFontSize: "Adjust Font Size",
  adjustBrightness: "Adjust Screen Brightness",

  // Treatment Process Section
  treatmentProcessTitle: "Our Treatment Process",
  treatmentProcessSubtitle:
    "Dr. Neiman follows a structured approach to ensure comprehensive care for every patient",
  initialConsultationStep: "Initial Consultation",
  initialConsultationDesc:
    "A thorough review of your medical history, symptoms, and concerns to establish a baseline understanding of your condition.",
  comprehensiveDiagnosisStep: "Comprehensive Diagnosis",
  comprehensiveDiagnosisDesc:
    "Advanced diagnostic procedures including imaging, laboratory tests, and biopsies to precisely identify your cancer type and stage.",
  personalizedTreatmentPlanningStep: "Personalized Treatment Planning",
  personalizedTreatmentPlanningDesc:
    "Developing an individualized treatment strategy that considers your specific cancer profile, overall health, and personal preferences.",
  treatmentImplementationStep: "Treatment Implementation",
  treatmentImplementationDesc:
    "Careful administration of selected treatments with regular monitoring and adjustments as needed.",
  followUpCareStep: "Follow-Up Care",
  followUpCareDesc:
    "Ongoing assessments to track your progress, manage side effects, and make necessary changes to your treatment plan.",
  survivorshipPlanningStep: "Survivorship Planning",
  survivorshipPlanningDesc:
    "Long-term care planning focused on preventing recurrence, monitoring late treatment effects, and supporting your return to wellness.",

  // FAQ questions and answers
  faqCancerTypes: "What types of cancer does Dr. Neiman specialize in?",
  faqCancerTypesAnswer:
    "Dr. Neiman specializes in treating a wide range of cancers, with particular expertise in breast cancer, lung cancer, gastrointestinal cancers, and lymphomas.",
  faqTreatmentTime: "How long does a typical treatment process take?",
  faqTreatmentTimeAnswer:
    "The duration of cancer treatment varies significantly depending on the type and stage of cancer, as well as the specific treatment approach. During your consultation, Dr. Neiman will provide you with a detailed timeline based on your individual case.",
  faqTeam: "Does Dr. Neiman work with a multidisciplinary team?",
  faqTeamAnswer:
    "Yes, Dr. Neiman collaborates with a comprehensive team of healthcare professionals including surgeons, radiation oncologists, pathologists, nurses, nutritionists, and mental health professionals to ensure holistic care for each patient.",
  faqFirstAppointment: "What should I bring to my first appointment?",
  faqFirstAppointmentAnswer:
    "Please bring your medical records, including previous test results, scans, and pathology reports. Also, bring a list of current medications, insurance information, and any questions you may have.",
  faqTelemedicine: "Are telemedicine consultations available?",
  faqTelemedicineAnswer:
    "Yes, Dr. Neiman offers telemedicine appointments for appropriate situations such as follow-up consultations and certain types of treatment discussions.",

  // Patient Stories
  patientStoriesTitle: "Patient Stories",
  patientStoriesDescription: "Patients share their experiences and journeys with Dr. Neiman and the treatments they received.",
  
  // Admin section
  messages: "Messages",
  messagesManagement: "Messages Management",
  recentMessages: "Recent Messages",
  messageDetails: "Message Details",
  allMessages: "All Messages",
  noMessages: "No messages found",
  markAsRead: "Mark as Read",
  markAsUnread: "Mark as Unread",
  messageFrom: "Message from",
  sent: "Sent",
  reply: "Reply",
  deleteMessage: "Delete Message",
  faqsManagement: "FAQs Management",
  addFaq: "Add FAQ",
  editFaq: "Edit FAQ",
  question: "Question",
  answer: "Answer",
  contentManagement: "Content Management",
  footerManagement: "Footer Management",
  contactInfoManagement: "Contact Information Management",
  biographyManagement: "Biography Management",
  editContent: "Edit Content",
  save: "Save",
  cancel: "Cancel",
  contentUpdated: "Content updated successfully",
  contentCreated: "Content created successfully",
  contentDeleted: "Content deleted successfully",
  confirmDelete: "Are you sure you want to delete this item?",
  addNew: "Add New",
  emptyState: "No items found. Click 'Add New' to create one.",
  allStories: "All Stories",
  breastCancer: "Breast Cancer",
  lungCancer: "Lung Cancer",
  gastrointestinal: "Gastrointestinal",
  lymphoma: "Lymphoma",
  melanoma: "Melanoma", // Added missing category
  prostate: "Prostate Cancer", // Added missing category
  videoTestimonials: "Video Testimonials",
  videoTestimonialsDescription:
    "Watch video testimonials from patients sharing their experience with Dr. Neiman",
  featuredStories: "Featured Stories",
  featuredStoriesDescription:
    "Special stories highlighting Dr. Neiman's comprehensive and personal approach to cancer care.",
  readFullStory: "Read Full Story",
  noStoriesFound: "No stories found in this category.",
  watchVideo: "Watch Video",
  backToVideos: "Back to Videos",
  diagnosis: "Diagnosis",
  treatment: "Treatment",
  treatmentJourney: "Treatment Journey",
  patientStory: "Patient Story",
  shareStory: "Share Your Story",
  fullStory: "Full Story",
  videoTestimonial: "Video Testimonial",
  noVideosFound: "No video testimonials found",

  // Appointment management translations
  appointmentManagement: "Appointment Management",
  editAppointment: "Edit Appointment",
  deleteAppointment: "Delete Appointment",
  confirmDeleteAppointment: "Are you sure you want to delete this appointment?",
  appointmentUpdated: "Appointment updated successfully",
  appointmentDeleted: "Appointment deleted successfully",
  noAppointments: "No appointments scheduled yet",

  // Video management translations
  videoManagement: "Video Management",
  addVideo: "Add Video",
  editVideo: "Edit Video",
  deleteVideo: "Delete Video",
  confirmDeleteVideo: "Are you sure you want to delete this video?",
  videoAdded: "Video added successfully",
  videoUpdated: "Video updated successfully",
  videoDeleted: "Video deleted successfully",
  
  // Admin general
  viewAll: "View All",
  scheduleNew: "Schedule New",
  status: "Status",
  actions: "Actions",
  patient: "Patient",
  contact: "Contact",
  dateTime: "Date & Time",
  reason: "Reason",

  // Credentials section
  educationCredentials: "Education & Credentials",
  education: "Education",
  medicalDegree: "Medical Degree",
  sovietUniversityMedicine: "Soviet Union University of Medicine",
  specialization: "Specialization",
  rabinMedicalCenter: "Rabin Medical Center",
  internalMedicineOncology: "Internal Medicine, Clinical Oncology, and Radiotherapy",
  
  currentPosition: "Current Position",
  davidoffCancerCenter: "Davidoff Cancer Center, Rabin Medical Center",
  oncologyDepartmentHead: "Head of Oncology Inpatient Department",
  
  professionalAffiliations: "Professional Affiliations",
  professionalMemberships: "Professional Memberships",
  israeliOncologySociety: "Israeli Society of Clinical Oncology and Radiotherapy",
  israeliInternalMedicine: "Israeli Society of Internal Medicine",
  israeliUrologySociety: "Israeli Society of Urology",
  esmoMembership: "European Society for Medical Oncology (ESMO)",
  
  // Biography Section
  professionalBiography: "Professional Biography",
  biographyText1: "Dr. Victoria Neiman is a leading expert in Clinical Oncology, Internal Medicine, and Radiotherapy, with over 30 years of experience. She serves as the Head of the Oncology Inpatient Department at the Davidoff Cancer Center, part of Rabin Medical Center (Beilinson).",
  biographyText2: "Her areas of specialization include internal medicine, clinical oncology, and radiotherapy, with a special focus on uro-oncological tumors and breast cancer. She treats a wide range of diseases, including kidney, prostate, bladder, and testicular cancer.",
  biographyText3: "After completing her medical studies at a university in the Soviet Union, Dr. Neiman specialized in internal medicine, clinical oncology, and radiotherapy at Rabin Medical Center. She lectures at the Sackler School of Medicine at Tel Aviv University and at the School of Nursing.",
  biographyText4: "She is actively involved in numerous clinical trials, including international research on breast, kidney, urinary system, and prostate cancer. Her research contributes to advancing oncological treatment and understanding of the disease.",
  biographyText5: "Dr. Neiman is a member of leading professional associations, including the Society for Clinical Oncology and Radiotherapy, the Israeli Society of Internal Medicine, the Israeli Urological Association, and the European Society for Medical Oncology (ESMO).",
  biographyText6: "Her patients consistently note her professionalism, humanity, and exceptional availability.",
  biographyText7: "Dr. Neiman is considered a central figure in the field of oncology in Israel, combining deep clinical knowledge with a humane and empathetic approach. She leads medical and research teams and invests heavily in training the next generation of doctors.",
  biographyText8: "Additionally, she participates in professional conferences, gives lectures, and publishes articles in her field of expertise. She strives to provide the highest level of medical care while offering personal attention and support to her patients.",
  biographyText9: "Her approach to patient care combines cutting-edge medical expertise with deep compassion, ensuring each patient receives personalized treatment tailored to their specific needs and circumstances.",
  biographyText10: "Dr. Neiman speaks Hebrew, English, and Russian, offering medical services to a wide range of patients.",
  
  // Contact page translations
  contactUs: "Contact Us",
  contactDescription: "Have questions or need to get in touch with Dr. Victoria Neiman? We're here to help.",
  sendUsMessage: "Send Us a Message",
  subject: "Subject",
  message: "Message",
  messagePlaceHolder: "Please provide details about your inquiry",
  submitMessage: "Send Message",
  officeAddress: "Address",
  officePhone: "Phone",
  officeEmail: "Email",
  messageSent: "Your message has been sent! We will get back to you shortly.",
  errorSending: "Error sending message",
  enterValidEmail: "Please enter a valid email.",
  enterValidPhone: "Please enter a valid phone number.",
  nameRequired: "Name is required",
  subjectRequired: "Subject is required",
  messageRequired: "Message is required",
  frequently: "Frequently Asked Questions",
  appointmentQuestion: "How do I schedule an appointment?",
  appointmentAnswer: "You can schedule an appointment by calling our office, using the online appointment form, or sending us an email.",
  referralQuestion: "Do I need a referral?",
  referralAnswer: "While a referral from your primary care physician is helpful, it is not always required. Please contact our office to discuss your specific situation.",
  insuranceQuestion: "What insurance plans do you accept?",
  insuranceAnswer: "We work with most major health insurance providers. Please contact our office for specific information about your insurance coverage.",
  aboutDoctorHeader: "About Dr. Victoria Neiman",
  loadMore: "Load More",
};
